import { DEV, UTHORIZATION_COOKIE_APP } from "../../config";

export const AUTHORIZATION_COOKIE = UTHORIZATION_COOKIE_APP;
export const LOGIN_ATTEMPTS = "loginAttempts";
export const __DEV__ = DEV;
export const SUCCESS = "success";
export const INFO = "info";
export const ERROR = "error";
export const WARNING = "warning";
export const GUEST = "GUEST";
export const PAGINATION_SIZE = [
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "50", value: 50 },
  { label: "200", value: 200 },
  { label: "500", value: 500 },
  { label: "1000", value: 1000 },
];
export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGESIZE = 10;
//DANH MUC CONST
export const MA_DANH_MUC = {
  KhoiToChuc: { Ma: "KhoiToChuc", Ten: "Khối đơn vị, tổ chức..." },
  LoaiDanhMuc: { Ma: "LoaiDanhMuc", Ten: "Loại danh mục..." },
};
export const DATE_FORMAT = "DD/MM/YYYY";
export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const VN_PHONE_NUMBER = /^(\+84|0)\d{9}$/;
export const MA_PATTERN = /^[a-z0-9_.]+$/i;
export const PASSWORD_PATTERN = /^(?=.*[@#$%&])[A-Za-z\d@#$%&]+$/;
export const ACCOUNT_PATTERN = /^[a-z0-9_]+$/i;
export const LABEL_VALID_ERROR_NAME = require("./formValidate").LABEL_VALID_ERROR_NAME;
export const CCCD_PATTERN = /^\d{12}$/;
export const STRING_PATTERN = /^\S(?:.*\S)?$/;
